import React, {useEffect} from 'react';
import ModelUploadPageHeader from '../common/ModelUploadPageHeader';
import ModelUploadFooter from '../common/ModelUploadFooter';
import ModelEditPermissionsForm, {
  ModelEditPermissionsFormData,
} from '../../model/common/ModelEdit/ModelEditPermissons/ModelEditPermissionsForm';
import {isModelWeb} from '../../../../store/model';
import {trackPermissionsTabEvent} from '../../../../tracking/tracking';
import StepPermissionsRedesigned from './StepPermissionsRedesigned';
import ModelUploadFooterAntd from '../common/ModelUploadFooterAntd';

type StepPermissionsProps = {
  permissions: ModelEditPermissionsFormData;
  onSubmit: (permissions: ModelEditPermissionsFormData) => void;
  onChange: (permissions: ModelEditPermissionsFormData) => void;
  useRedesign?: boolean;
  onBack?: () => void;
  buttons?: (params: {onBack?: () => void; nextHtmlType?: 'button' | 'submit' | 'reset'}) => React.ReactNode;
};

const footerComp = () => {
  return <ModelUploadFooter />;
};

const StepPermissions: React.FC<StepPermissionsProps> = ({
  onSubmit,
  onChange,
  permissions,
  useRedesign = false,
  onBack,
  buttons,
}) => {
  const model = permissions.model;
  const webModel = isModelWeb(model);

  useEffect(() => {
    trackPermissionsTabEvent();
  }, []);

  const renderButtonsAntd = (params: {onBack?: () => void; nextHtmlType?: 'button' | 'submit' | 'reset'}) => (
    <ModelUploadFooterAntd
      onBack={params.onBack}
      nextHtmlType={params.nextHtmlType || 'submit'}
      nextText="Save & Proceed"
    />
  );

  if (useRedesign) {
    return (
      <StepPermissionsRedesigned
        permissions={permissions}
        onSubmit={onSubmit}
        onChange={onChange}
        onBack={onBack}
        buttons={buttons || renderButtonsAntd}
        webModel={webModel}
      />
    );
  }

  // Original version
  return (
    <div>
      <ModelUploadPageHeader title="Setup Editors and Viewers" subTitle="You are automatically set as Editor." />

      <div className="whiteTheme" style={{maxWidth: '80rem', margin: '0 auto'}}>
        <ModelEditPermissionsForm
          onSubmit={onSubmit}
          onChange={onChange}
          data={permissions}
          webModel={webModel}
          buttons={footerComp}
          model={model}
        />
      </div>
    </div>
  );
};

export default StepPermissions;
